const PageReady = (function () {
  return {
    ready: (initFunction) => {
      if (document.readyState !== 'loading') {
        initFunction()
      } else {
        document.addEventListener('DOMContentLoaded', initFunction)
      }
    },
  }
})()

export default PageReady
